/*
 Instagram Post is a component that embeds Instagram posts.
 The code below Instagram's official embed code, slightly modified so fit our ESLint rules, and to dynamically pass in postID
*/
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var InstagramPost = function InstagramPost(_ref) {
  var postId = _ref.postId;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "offset-md-3",
    md: 6,
    sm: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: "embed-responsive embed-responsive-1by2 instagram-post"
  }, /*#__PURE__*/React.createElement("iframe", {
    title: "instagram-post",
    className: "embed-responsive-item",
    width: "400",
    height: "610",
    src: "https://instagram.com/p/" + postId + "/embed"
  }))));
};
export { InstagramPost };